export default "__VITE_ASSET__MsCQarR6__";